import block from '@/mixins/block'

export default {
  name: 'block_button',
  mixins: [block]
}
